import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useStyles from './styles';
import { useStore } from 'src/stores';
import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Icon } from '@livable/saas-react-components';
import { PAYMENT_METHODS } from 'src/constants/payments';
import { ReimbursementModalV2 } from '../ReimbursementModal';
import { ReimbursementModal } from 'src/components/settings/ReimbursementModal';
import { Paper, Typography, Accordion, AccordionSummary, AccordionDetails, Chip } from '@mui/material';
export const PaymentMethod = observer(_ref => {
  var _payoutData$propertyI, _payoutData$propertyI2, _payoutData;
  let propertyAddress = _ref.propertyAddress,
    propertyId = _ref.propertyId,
    propertiesAddresses = _ref.propertiesAddresses,
    payoutData = _ref.payoutData,
    triggerReload = _ref.triggerReload;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  const propertiesAddressesList = payoutData === null || payoutData === void 0 || (_payoutData$propertyI = payoutData.propertyIds) === null || _payoutData$propertyI === void 0 ? void 0 : _payoutData$propertyI.map(item => {
    var _propertiesAddresses$, _propertiesAddresses$2, _propertiesAddresses$3, _propertiesAddresses$4, _propertiesAddresses$5;
    return "".concat((_propertiesAddresses$ = propertiesAddresses[item]) === null || _propertiesAddresses$ === void 0 ? void 0 : _propertiesAddresses$.street, " ").concat((_propertiesAddresses$2 = propertiesAddresses[item]) === null || _propertiesAddresses$2 === void 0 ? void 0 : _propertiesAddresses$2.city, ", ").concat((_propertiesAddresses$3 = propertiesAddresses[item]) === null || _propertiesAddresses$3 === void 0 ? void 0 : _propertiesAddresses$3.state, " ").concat((_propertiesAddresses$4 = propertiesAddresses[item]) === null || _propertiesAddresses$4 === void 0 ? void 0 : _propertiesAddresses$4.zip, " ").concat(item !== null && item !== void 0 && item.secondary ? ', ' + ((_propertiesAddresses$5 = propertiesAddresses[item]) === null || _propertiesAddresses$5 === void 0 ? void 0 : _propertiesAddresses$5.secondary) : '');
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, store.account.featureFlagsStore.getIsNewPayoutEnabled && /*#__PURE__*/React.createElement(Paper, {
    variant: "basic",
    key: 'PaymentMethod' + (payoutData === null || payoutData === void 0 ? void 0 : payoutData.id)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.paperContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.method
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "coins"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.details
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    className: classes.methodName
  }, "Account holder: ", payoutData.nameOnAccount)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.methodName
  }, /*#__PURE__*/React.createElement("b", null, "Depository name:"), " ", payoutData.depositoryName, " ", /*#__PURE__*/React.createElement("b", null, "Account number:"), ' ', payoutData.accountNumber, " ", /*#__PURE__*/React.createElement("b", null, "Routing number:"), " ", payoutData.routingNumber)))), /*#__PURE__*/React.createElement("div", {
    className: classes.actions
  }, /*#__PURE__*/React.createElement(ReimbursementModalV2, {
    propertyAddresses: propertiesAddressesList.join('; '),
    payoutData: payoutData,
    triggerReload: triggerReload
  }))), (payoutData === null || payoutData === void 0 ? void 0 : payoutData.propertyIds) && (payoutData === null || payoutData === void 0 || (_payoutData$propertyI2 = payoutData.propertyIds) === null || _payoutData$propertyI2 === void 0 ? void 0 : _payoutData$propertyI2.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.accordionWrapper
  }, /*#__PURE__*/React.createElement(Accordion, {
    className: classes.accordion,
    expanded: isOpen
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    "aria-controls": "allocation-content",
    id: "allocation-header",
    expandIcon: /*#__PURE__*/React.createElement(Icon, {
      fontSize: "large",
      type: "arrow-line-right"
    }),
    onClick: () => setIsOpen(prevValue => !prevValue)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.accordionContent
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "View list of assigned properties"))), /*#__PURE__*/React.createElement(AccordionDetails, {
    className: classes.accordionDetails
  }, propertiesAddressesList.map((item, i) => /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    key: i
  }, item)))))), !store.account.featureFlagsStore.getIsNewPayoutEnabled && /*#__PURE__*/React.createElement(Paper, {
    variant: "basic",
    key: 'PaymentMethod' + propertyId
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.paperContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.method
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "building"
  }), /*#__PURE__*/React.createElement(Icon, {
    type: "coins"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    className: classes.methodName
  }, propertyAddress)), /*#__PURE__*/React.createElement("div", {
    className: classes.actions
  }, /*#__PURE__*/React.createElement(Chip, {
    label: (_payoutData = payoutData["".concat(PAYMENT_METHODS.ACH)]) !== null && _payoutData !== void 0 && _payoutData.isPrimary ? t('subscriptions.ach') : t('subscriptions.check'),
    className: classes.primaryPaymentMethod,
    size: "large",
    variant: "success",
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "success"
    })
  }), /*#__PURE__*/React.createElement(ReimbursementModal, {
    propertyAddress: propertyAddress,
    propertyId: propertyId,
    payoutData: payoutData,
    triggerReload: triggerReload
  })))));
});